/* eslint-disable */
import { BehaviorSubject, Subject } from "rxjs";
import { get, del, put, post } from "../../../http";
import { isAuth, getToken } from "../../../auth/shared/utils/auth";
import { userService } from "../../../user";

export type User = {
  id?: number;
  name: string;
  surname: string;
  email: string;
  departmentId: number;
  registrationDate?: string;
  profilePicture?: string;
};

export type PasswordExpiration = {
  startDate: number;
  expirationMonthCount: number;
};

export enum AdministrationError {
  Network,
  Server,
  InvalidCredentials,
  NotVerified,
  DuplicateEmail,
}

export class AdministrationService {
  private _baseUrl: string;
  private _passwordSettingsUrl: string;
  private _users$ = new BehaviorSubject<User[]>([]);
  private _error$ = new Subject<AdministrationError | null>();
  private _loading$ = new BehaviorSubject<boolean>(false);
  private _passwordExpire$ = new BehaviorSubject<PasswordExpiration>({startDate: Date.now(), expirationMonthCount: 12});

  public get error$() {
    return this._error$.asObservable();
  }

  public get users$() {
    return this._users$.asObservable();
  }

  public get users() {
    return this._users$.value;
  }

  public get passwordExpire$() {
    return this._passwordExpire$.asObservable();
  }

  public get passwordExpire() {
    return this._passwordExpire$.value;
  }

  public get loading$() {
    return this._loading$.asObservable();
  }

  public get loading() {
    return this._loading$.value;
  }

  constructor(apiUrl: string) {
    this._baseUrl = apiUrl + "/administration/Users";
    this._passwordSettingsUrl = apiUrl + "/administration/PasswordSettings";
  }

  // TODO Вынести в глобальный метод добавление заголовка
  addAuthInHeadersOption = () => {
    let options = {};
    if (isAuth()) {
      const token = getToken();
      options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
    return options;
  };

  async getUsersList(paramSort?: number) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      const result = await get(`${this._baseUrl}`, paramSort ? { sort: paramSort } : undefined, options);
      result.json().then((res) => {
        this._users$.next(res);
      });

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("get users list fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async createUser(userInfo: User) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      const result = await post(`${this._baseUrl}`, userInfo, options);
      return result.json().then((res) => {
        if (res && res.status === 409) {
          this._error$.next(AdministrationError.DuplicateEmail);
          return false;
        } else if (res.length > 0 && res[0].code === "DuplicateUserName") {
          this._error$.next(AdministrationError.DuplicateEmail);
          return false;
        } else {
          this._users$.next([...this.users, res]);
        }
        this._loading$.next(false);
        return true;
      });
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("create user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async updateUser(userInfo: User) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await put(`${this._baseUrl}/${userInfo.id}`, userInfo, options);
      this.updateDataUser(userInfo, userInfo.id!);
      await userService.getUserInfo();

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("udpate user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  async deleteUser(userId: number) {
    try {
      this._loading$.next(true);

      const options = this.addAuthInHeadersOption();
      await del(`${this._baseUrl}/${userId}`, options);
      this.updateDeletedUser(userId);

      this._loading$.next(false);
    } catch (err) {
      this._loading$.next(false);

      // TODO: Добавить логику обработки ошибок
      // eslint-disable-next-line no-console
      console.error("delete user fail");
      // eslint-disable-next-line no-console
      console.error(err);
      throw err;
    }
  }

  updateDataUser = (userInfo: User, userId: number) => {
    const userIndex = this.users.findIndex((u) => u.id === userId);
    const emptyFindIndex = -1;
    if (userIndex !== emptyFindIndex) {
      const users = [...this.users];
      users[userIndex] = {
        ...users[userIndex],
        ...userInfo,
      };
      this._users$.next(users);
    }
  };

  updateDeletedUser = (userId: number) => {
    const userIndex = this.users.findIndex((u) => u.id === userId);
    const emptyFindIndex = -1;
    if (userIndex !== emptyFindIndex) {
      const deleteCount = 1;
      const users = [...this.users];
      users.splice(userIndex, deleteCount);
      this._users$.next(users);
    }
  };
  getExpirePeriod = async () => {
    try {
      this._loading$.next(true);
    const options = this.addAuthInHeadersOption();
    const result = await get(`${this._passwordSettingsUrl}`, undefined, options);
    result.json().then((res) => {
      this._passwordExpire$.next(res);
    });
    this._loading$.next(false);
  } catch (err) {
    this._loading$.next(false);
    console.error("get users list fail");
    console.error(err);
    throw err;
  }
  };
  setExpirePeriod = async (period: string) => {
    const body = { expirationMonthCount: period };
    const options = this.addAuthInHeadersOption();
    await put(`${this._passwordSettingsUrl}`, body, options);
  };
}
